var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/Concerns/RayScreenColors.ts
var RayScreenColors = class {
  /* istanbul ignore next */
  screenColor(color) {
    return this;
  }
  screenGreen() {
    return this.screenColor("green");
  }
  screenOrange() {
    return this.screenColor("orange");
  }
  screenRed() {
    return this.screenColor("red");
  }
  screenPurple() {
    return this.screenColor("purple");
  }
  screenBlue() {
    return this.screenColor("blue");
  }
  screenGray() {
    return this.screenColor("gray");
  }
};
__name(RayScreenColors, "RayScreenColors");

// node_modules/ts-mixer/dist/esm/index.js
var copyProps = /* @__PURE__ */ __name((dest, src, exclude = []) => {
  const props = Object.getOwnPropertyDescriptors(src);
  for (let prop of exclude)
    delete props[prop];
  Object.defineProperties(dest, props);
}, "copyProps");
var protoChain = /* @__PURE__ */ __name((obj, currentChain = [obj]) => {
  const proto = Object.getPrototypeOf(obj);
  if (proto === null)
    return currentChain;
  return protoChain(proto, [...currentChain, proto]);
}, "protoChain");
var nearestCommonProto = /* @__PURE__ */ __name((...objs) => {
  if (objs.length === 0)
    return void 0;
  let commonProto = void 0;
  const protoChains = objs.map((obj) => protoChain(obj));
  while (protoChains.every((protoChain2) => protoChain2.length > 0)) {
    const protos = protoChains.map((protoChain2) => protoChain2.pop());
    const potentialCommonProto = protos[0];
    if (protos.every((proto) => proto === potentialCommonProto))
      commonProto = potentialCommonProto;
    else
      break;
  }
  return commonProto;
}, "nearestCommonProto");
var hardMixProtos = /* @__PURE__ */ __name((ingredients, constructor, exclude = []) => {
  var _a;
  const base = (_a = nearestCommonProto(...ingredients)) !== null && _a !== void 0 ? _a : Object.prototype;
  const mixedProto = Object.create(base);
  const visitedProtos = protoChain(base);
  for (let prototype of ingredients) {
    let protos = protoChain(prototype);
    for (let i = protos.length - 1; i >= 0; i--) {
      let newProto = protos[i];
      if (visitedProtos.indexOf(newProto) === -1) {
        copyProps(mixedProto, newProto, ["constructor", ...exclude]);
        visitedProtos.push(newProto);
      }
    }
  }
  mixedProto.constructor = constructor;
  return mixedProto;
}, "hardMixProtos");
var unique = /* @__PURE__ */ __name((arr) => arr.filter((e, i) => arr.indexOf(e) == i), "unique");
var getIngredientWithProp = /* @__PURE__ */ __name((prop, ingredients) => {
  const protoChains = ingredients.map((ingredient) => protoChain(ingredient));
  let protoDepth = 0;
  let protosAreLeftToSearch = true;
  while (protosAreLeftToSearch) {
    protosAreLeftToSearch = false;
    for (let i = ingredients.length - 1; i >= 0; i--) {
      const searchTarget = protoChains[i][protoDepth];
      if (searchTarget !== void 0 && searchTarget !== null) {
        protosAreLeftToSearch = true;
        if (Object.getOwnPropertyDescriptor(searchTarget, prop) != void 0) {
          return protoChains[i][0];
        }
      }
    }
    protoDepth++;
  }
  return void 0;
}, "getIngredientWithProp");
var proxyMix = /* @__PURE__ */ __name((ingredients, prototype = Object.prototype) => new Proxy({}, {
  getPrototypeOf() {
    return prototype;
  },
  setPrototypeOf() {
    throw Error("Cannot set prototype of Proxies created by ts-mixer");
  },
  getOwnPropertyDescriptor(_, prop) {
    return Object.getOwnPropertyDescriptor(getIngredientWithProp(prop, ingredients) || {}, prop);
  },
  defineProperty() {
    throw new Error("Cannot define new properties on Proxies created by ts-mixer");
  },
  has(_, prop) {
    return getIngredientWithProp(prop, ingredients) !== void 0 || prototype[prop] !== void 0;
  },
  get(_, prop) {
    return (getIngredientWithProp(prop, ingredients) || prototype)[prop];
  },
  set(_, prop, val) {
    const ingredientWithProp = getIngredientWithProp(prop, ingredients);
    if (ingredientWithProp === void 0)
      throw new Error("Cannot set new properties on Proxies created by ts-mixer");
    ingredientWithProp[prop] = val;
    return true;
  },
  deleteProperty() {
    throw new Error("Cannot delete properties on Proxies created by ts-mixer");
  },
  ownKeys() {
    return ingredients.map(Object.getOwnPropertyNames).reduce((prev, curr) => curr.concat(prev.filter((key) => curr.indexOf(key) < 0)));
  }
}), "proxyMix");
var softMixProtos = /* @__PURE__ */ __name((ingredients, constructor) => proxyMix([...ingredients, { constructor }]), "softMixProtos");
var settings = {
  initFunction: null,
  staticsStrategy: "copy",
  prototypeStrategy: "copy",
  decoratorInheritance: "deep"
};
var mixins = /* @__PURE__ */ new Map();
var getMixinsForClass = /* @__PURE__ */ __name((clazz) => mixins.get(clazz), "getMixinsForClass");
var registerMixins = /* @__PURE__ */ __name((mixedClass, constituents) => mixins.set(mixedClass, constituents), "registerMixins");
var hasMixin = /* @__PURE__ */ __name((instance, mixin) => {
  if (instance instanceof mixin)
    return true;
  const constructor = instance.constructor;
  const visited = /* @__PURE__ */ new Set();
  let frontier = /* @__PURE__ */ new Set();
  frontier.add(constructor);
  while (frontier.size > 0) {
    if (frontier.has(mixin))
      return true;
    frontier.forEach((item) => visited.add(item));
    const newFrontier = /* @__PURE__ */ new Set();
    frontier.forEach((item) => {
      var _a;
      const itemConstituents = (_a = mixins.get(item)) !== null && _a !== void 0 ? _a : protoChain(item.prototype).map((proto) => proto.constructor).filter((item2) => item2 !== null);
      if (itemConstituents)
        itemConstituents.forEach((constituent) => {
          if (!visited.has(constituent) && !frontier.has(constituent))
            newFrontier.add(constituent);
        });
    });
    frontier = newFrontier;
  }
  return false;
}, "hasMixin");
var mergeObjectsOfDecorators = /* @__PURE__ */ __name((o1, o2) => {
  var _a, _b;
  const allKeys = unique([...Object.getOwnPropertyNames(o1), ...Object.getOwnPropertyNames(o2)]);
  const mergedObject = {};
  for (let key of allKeys)
    mergedObject[key] = unique([...(_a = o1 === null || o1 === void 0 ? void 0 : o1[key]) !== null && _a !== void 0 ? _a : [], ...(_b = o2 === null || o2 === void 0 ? void 0 : o2[key]) !== null && _b !== void 0 ? _b : []]);
  return mergedObject;
}, "mergeObjectsOfDecorators");
var mergePropertyAndMethodDecorators = /* @__PURE__ */ __name((d1, d2) => {
  var _a, _b, _c, _d;
  return {
    property: mergeObjectsOfDecorators((_a = d1 === null || d1 === void 0 ? void 0 : d1.property) !== null && _a !== void 0 ? _a : {}, (_b = d2 === null || d2 === void 0 ? void 0 : d2.property) !== null && _b !== void 0 ? _b : {}),
    method: mergeObjectsOfDecorators((_c = d1 === null || d1 === void 0 ? void 0 : d1.method) !== null && _c !== void 0 ? _c : {}, (_d = d2 === null || d2 === void 0 ? void 0 : d2.method) !== null && _d !== void 0 ? _d : {})
  };
}, "mergePropertyAndMethodDecorators");
var mergeDecorators = /* @__PURE__ */ __name((d1, d2) => {
  var _a, _b, _c, _d, _e, _f;
  return {
    class: unique([...(_a = d1 === null || d1 === void 0 ? void 0 : d1.class) !== null && _a !== void 0 ? _a : [], ...(_b = d2 === null || d2 === void 0 ? void 0 : d2.class) !== null && _b !== void 0 ? _b : []]),
    static: mergePropertyAndMethodDecorators((_c = d1 === null || d1 === void 0 ? void 0 : d1.static) !== null && _c !== void 0 ? _c : {}, (_d = d2 === null || d2 === void 0 ? void 0 : d2.static) !== null && _d !== void 0 ? _d : {}),
    instance: mergePropertyAndMethodDecorators((_e = d1 === null || d1 === void 0 ? void 0 : d1.instance) !== null && _e !== void 0 ? _e : {}, (_f = d2 === null || d2 === void 0 ? void 0 : d2.instance) !== null && _f !== void 0 ? _f : {})
  };
}, "mergeDecorators");
var decorators = /* @__PURE__ */ new Map();
var findAllConstituentClasses = /* @__PURE__ */ __name((...classes) => {
  var _a;
  const allClasses = /* @__PURE__ */ new Set();
  const frontier = /* @__PURE__ */ new Set([...classes]);
  while (frontier.size > 0) {
    for (let clazz of frontier) {
      const protoChainClasses = protoChain(clazz.prototype).map((proto) => proto.constructor);
      const mixinClasses = (_a = getMixinsForClass(clazz)) !== null && _a !== void 0 ? _a : [];
      const potentiallyNewClasses = [...protoChainClasses, ...mixinClasses];
      const newClasses = potentiallyNewClasses.filter((c) => !allClasses.has(c));
      for (let newClass of newClasses)
        frontier.add(newClass);
      allClasses.add(clazz);
      frontier.delete(clazz);
    }
  }
  return [...allClasses];
}, "findAllConstituentClasses");
var deepDecoratorSearch = /* @__PURE__ */ __name((...classes) => {
  const decoratorsForClassChain = findAllConstituentClasses(...classes).map((clazz) => decorators.get(clazz)).filter((decorators2) => !!decorators2);
  if (decoratorsForClassChain.length == 0)
    return {};
  if (decoratorsForClassChain.length == 1)
    return decoratorsForClassChain[0];
  return decoratorsForClassChain.reduce((d1, d2) => mergeDecorators(d1, d2));
}, "deepDecoratorSearch");
var directDecoratorSearch = /* @__PURE__ */ __name((...classes) => {
  const classDecorators = classes.map((clazz) => getDecoratorsForClass(clazz));
  if (classDecorators.length === 0)
    return {};
  if (classDecorators.length === 1)
    return classDecorators[0];
  return classDecorators.reduce((d1, d2) => mergeDecorators(d1, d2));
}, "directDecoratorSearch");
var getDecoratorsForClass = /* @__PURE__ */ __name((clazz) => {
  let decoratorsForClass = decorators.get(clazz);
  if (!decoratorsForClass) {
    decoratorsForClass = {};
    decorators.set(clazz, decoratorsForClass);
  }
  return decoratorsForClass;
}, "getDecoratorsForClass");
var decorateClass = /* @__PURE__ */ __name((decorator) => (clazz) => {
  const decoratorsForClass = getDecoratorsForClass(clazz);
  let classDecorators = decoratorsForClass.class;
  if (!classDecorators) {
    classDecorators = [];
    decoratorsForClass.class = classDecorators;
  }
  classDecorators.push(decorator);
  return decorator(clazz);
}, "decorateClass");
var decorateMember = /* @__PURE__ */ __name((decorator) => (object, key, ...otherArgs) => {
  var _a, _b, _c;
  const decoratorTargetType = typeof object === "function" ? "static" : "instance";
  const decoratorType = typeof object[key] === "function" ? "method" : "property";
  const clazz = decoratorTargetType === "static" ? object : object.constructor;
  const decoratorsForClass = getDecoratorsForClass(clazz);
  const decoratorsForTargetType = (_a = decoratorsForClass === null || decoratorsForClass === void 0 ? void 0 : decoratorsForClass[decoratorTargetType]) !== null && _a !== void 0 ? _a : {};
  decoratorsForClass[decoratorTargetType] = decoratorsForTargetType;
  let decoratorsForType = (_b = decoratorsForTargetType === null || decoratorsForTargetType === void 0 ? void 0 : decoratorsForTargetType[decoratorType]) !== null && _b !== void 0 ? _b : {};
  decoratorsForTargetType[decoratorType] = decoratorsForType;
  let decoratorsForKey = (_c = decoratorsForType === null || decoratorsForType === void 0 ? void 0 : decoratorsForType[key]) !== null && _c !== void 0 ? _c : [];
  decoratorsForType[key] = decoratorsForKey;
  decoratorsForKey.push(decorator);
  return decorator(object, key, ...otherArgs);
}, "decorateMember");
var decorate = /* @__PURE__ */ __name((decorator) => (...args) => {
  if (args.length === 1)
    return decorateClass(decorator)(args[0]);
  return decorateMember(decorator)(...args);
}, "decorate");
function Mixin(...constructors) {
  var _a, _b, _c;
  const prototypes = constructors.map((constructor) => constructor.prototype);
  const initFunctionName = settings.initFunction;
  if (initFunctionName !== null) {
    const initFunctions = prototypes.map((proto) => proto[initFunctionName]).filter((func) => typeof func === "function");
    const combinedInitFunction = /* @__PURE__ */ __name(function(...args) {
      for (let initFunction of initFunctions)
        initFunction.apply(this, args);
    }, "combinedInitFunction");
    const extraProto = { [initFunctionName]: combinedInitFunction };
    prototypes.push(extraProto);
  }
  function MixedClass(...args) {
    for (const constructor of constructors)
      copyProps(this, new constructor(...args));
    if (initFunctionName !== null && typeof this[initFunctionName] === "function")
      this[initFunctionName].apply(this, args);
  }
  __name(MixedClass, "MixedClass");
  MixedClass.prototype = settings.prototypeStrategy === "copy" ? hardMixProtos(prototypes, MixedClass) : softMixProtos(prototypes, MixedClass);
  Object.setPrototypeOf(MixedClass, settings.staticsStrategy === "copy" ? hardMixProtos(constructors, null, ["prototype"]) : proxyMix(constructors, Function.prototype));
  let DecoratedMixedClass = MixedClass;
  if (settings.decoratorInheritance !== "none") {
    const classDecorators = settings.decoratorInheritance === "deep" ? deepDecoratorSearch(...constructors) : directDecoratorSearch(...constructors);
    for (let decorator of (_a = classDecorators === null || classDecorators === void 0 ? void 0 : classDecorators.class) !== null && _a !== void 0 ? _a : []) {
      const result = decorator(DecoratedMixedClass);
      if (result) {
        DecoratedMixedClass = result;
      }
    }
    applyPropAndMethodDecorators((_b = classDecorators === null || classDecorators === void 0 ? void 0 : classDecorators.static) !== null && _b !== void 0 ? _b : {}, DecoratedMixedClass);
    applyPropAndMethodDecorators((_c = classDecorators === null || classDecorators === void 0 ? void 0 : classDecorators.instance) !== null && _c !== void 0 ? _c : {}, DecoratedMixedClass.prototype);
  }
  registerMixins(DecoratedMixedClass, constructors);
  return DecoratedMixedClass;
}
__name(Mixin, "Mixin");
var applyPropAndMethodDecorators = /* @__PURE__ */ __name((propAndMethodDecorators, target) => {
  const propDecorators = propAndMethodDecorators.property;
  const methodDecorators = propAndMethodDecorators.method;
  if (propDecorators)
    for (let key in propDecorators)
      for (let decorator of propDecorators[key])
        decorator(target, key);
  if (methodDecorators)
    for (let key in methodDecorators)
      for (let decorator of methodDecorators[key])
        decorator(target, key, Object.getOwnPropertyDescriptor(target, key));
}, "applyPropAndMethodDecorators");
var mix = /* @__PURE__ */ __name((...ingredients) => (decoratedClass) => {
  const mixedClass = Mixin(...ingredients.concat([decoratedClass]));
  Object.defineProperty(mixedClass, "name", {
    value: decoratedClass.name,
    writable: false
  });
  return mixedClass;
}, "mix");

// src/Concerns/RayColors.ts
var RayColors = class {
  /* istanbul ignore next */
  color(name) {
    return this;
  }
  green() {
    return this.color("green");
  }
  orange() {
    return this.color("orange");
  }
  red() {
    return this.color("red");
  }
  purple() {
    return this.color("purple");
  }
  blue() {
    return this.color("blue");
  }
  gray() {
    return this.color("gray");
  }
};
__name(RayColors, "RayColors");

// src/Concerns/RaySizes.ts
var RaySizes = class {
  /* istanbul ignore next */
  size(size) {
    return this;
  }
  small() {
    return this.size("sm");
  }
  large() {
    return this.size("lg");
  }
};
__name(RaySizes, "RaySizes");

// src/Concerns/RemovesRayFrames.ts
var RemovesRayFrames = class {
  static removeRayFrames(frames) {
    const result = frames.filter((frame) => !RemovesRayFrames.isRayFrame(frame) && !RemovesRayFrames.isNodeFrame(frame));
    return result;
  }
  static isRayFrame(frame) {
    var _a;
    for (const rayNamespace of this.rayNamespaces()) {
      if ((_a = frame.fileName) == null ? void 0 : _a.includes(rayNamespace)) {
        return true;
      }
    }
    return false;
  }
  static isNodeFrame(frame) {
    var _a, _b;
    return ((_a = frame.fileName) == null ? void 0 : _a.includes("node:")) || ((_b = frame.fileName) == null ? void 0 : _b.includes("node_modules")) || false;
  }
  static rayNamespaces() {
    return ["ray-node/dist", "node-ray/dist", "vue-ray/dist", "-ray"];
  }
};
__name(RemovesRayFrames, "RemovesRayFrames");

// src/ConsoleInterceptor.ts
var consoleLog = console.log.bind({});
var consoleWrapper = /* @__PURE__ */ __name((...args) => {
  if (typeof Ray.client !== "undefined" && Ray.client.isRayAvailable()) {
    Ray.create().send(...args);
  }
  consoleLog(...args);
}, "consoleWrapper");
var _ConsoleInterceptor = class {
  enable() {
    _ConsoleInterceptor.active = true;
    console.log = consoleWrapper;
  }
  disable() {
    _ConsoleInterceptor.active = false;
    console.log = consoleLog;
  }
  active() {
    return _ConsoleInterceptor.active;
  }
};
var ConsoleInterceptor = _ConsoleInterceptor;
__name(ConsoleInterceptor, "ConsoleInterceptor");
ConsoleInterceptor.active = false;

// src/Origin/Hostname.ts
var _Hostname = class {
  static get() {
    var _a;
    return (_a = _Hostname.hostname) != null ? _a : "remote";
  }
  static set(hostname) {
    _Hostname.hostname = hostname;
  }
};
var Hostname = _Hostname;
__name(Hostname, "Hostname");
Hostname.hostname = null;

// src/ArgumentConverter.ts
import { format } from "@permafrost-dev/pretty-format";
var prettyFormat = format;
var ArgumentConverter = class {
  static convertToPrimitive(arg) {
    if (arg === null) {
      return { value: null, isHtml: false };
    }
    if (typeof arg === "string") {
      return { value: arg, isHtml: false };
    }
    if (typeof arg === "number") {
      return { value: arg, isHtml: false };
    }
    if (typeof arg === "boolean") {
      return { value: arg, isHtml: false };
    }
    return { value: ArgumentConverter.prettyFormatForHtml(arg), isHtml: true };
  }
  static prettyFormatForHtml(arg) {
    const formatted = prettyFormat(arg, { indent: "    " }).replace(/ /g, "&nbsp;").replace(/\r\n|\r|\n/g, "<br>").replace(/("[^"]+")/g, '<code style="font-size: 0.8rem!important;" class="bold text-green-600 p-0">$1</code>').replace(
      /Array(&nbsp;|\s)+(\[[^\]]+\])/g,
      '<code style="font-size: 0.8rem!important;" class="text-gray-500 p-0">Array$1$2</code>'
    ).replace(/^(\[[^\]]+\])$/g, '<code style="font-size: 0.8rem!important;"class="text-gray-500 p-0">$1</code>').replace(/(\{.+\})/g, '<code style="font-size: 0.8rem!important;" class="text-gray-600 ">$1</code>').replace(
      /(Array|Object|Function|Circular|Symbol|WeakMap|Map)/g,
      '<span style="font-size: 0.8rem!important;" class="text-yellow-600 bold">$1</span>'
    ).replace(/(true|false|null)/g, '<span style="font-size: 0.8rem!important;" class="text-indigo-600 bold">$1</span>').replace(/(:&nbsp;|[,[\]{}])/g, '<span style="font-size: 0.8rem!important;" class="text-orange-400 bold">$1</span>');
    return `<code style="font-size: 0.8rem!important;">${formatted}</code>`;
  }
};
__name(ArgumentConverter, "ArgumentConverter");

// src/Payloads/Payload.ts
var Payload = class {
  constructor() {
    this.remotePath = null;
    this.localPath = null;
    this.initialized = false;
    this.data = {
      type: "",
      content: "",
      origin: { function_name: "", file: "", line_number: 0, hostname: "remote" }
    };
  }
  replaceRemotePathWithLocalPath(filePath) {
    if (this.remotePath === null || this.localPath === null) {
      return filePath;
    }
    const pattern = new RegExp("^" + this.remotePath);
    return filePath.replace(pattern, this.localPath);
  }
  getContent() {
    return {};
  }
  toArray() {
    if (!this.initialized) {
      this.initialized = true;
      this.data.type = this.getType();
      this.data.content = this.getContent();
      this.data.origin.file = this.replaceRemotePathWithLocalPath(this.data.origin.file);
    }
    return this.data;
  }
  toJson() {
    return JSON.stringify(this.toArray());
  }
};
__name(Payload, "Payload");

// src/Payloads/BoolPayload.ts
var BoolPayload = class extends Payload {
  constructor(value) {
    super();
    this.value = value;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: this.value,
      label: "Boolean"
    };
  }
};
__name(BoolPayload, "BoolPayload");

// src/Payloads/HtmlPayload.ts
var HtmlPayload = class extends Payload {
  constructor(html = "") {
    super();
    this.html = html;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: this.html,
      label: "HTML"
    };
  }
};
__name(HtmlPayload, "HtmlPayload");

// src/Payloads/LogPayload.ts
var LogPayload = class extends Payload {
  constructor(values) {
    super();
    if (!Array.isArray(values)) {
      values = [values];
    }
    this.values = values;
  }
  static createForArguments(args) {
    const dumpedArguments = args.map((argument) => {
      return ArgumentConverter.convertToPrimitive(argument).value;
    });
    return new this(dumpedArguments);
  }
  getType() {
    return "log";
  }
  getContent() {
    return {
      values: this.values
    };
  }
};
__name(LogPayload, "LogPayload");

// src/Payloads/NullPayload.ts
var NullPayload = class extends Payload {
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: null,
      label: "Null"
    };
  }
};
__name(NullPayload, "NullPayload");

// src/PayloadFactory.ts
var PayloadFactory = class {
  static createForValues(args) {
    return new this(args).getPayloads();
  }
  static registerPayloadFinder(callable) {
    this.payloadFinder = callable;
  }
  constructor(values) {
    this.values = values;
  }
  getPayloads() {
    return this.values.map((value) => {
      return this.getPayload(value);
    });
  }
  getPayload(value) {
    if (typeof value === "boolean") {
      return new BoolPayload(value);
    }
    if (value === null) {
      return new NullPayload();
    }
    const convertedResult = ArgumentConverter.convertToPrimitive(value);
    if (convertedResult.isHtml) {
      return new HtmlPayload(convertedResult.value);
    }
    return new LogPayload(convertedResult.value);
  }
};
__name(PayloadFactory, "PayloadFactory");
PayloadFactory.payloadFinder = null;

// src/Payloads/CallerPayload.ts
var CallerPayload = class extends Payload {
  constructor(frames) {
    super();
    this.frames = RemovesRayFrames.removeRayFrames(frames);
  }
  getType() {
    return "caller";
  }
  getContent() {
    var _a, _b, _c, _d, _e, _f, _g;
    const frames = this.frames.slice(0);
    const frame = frames[0] || null;
    const funcNameParts = (_c = (_b = (_a = frame == null ? void 0 : frame.getFunctionName()) == null ? void 0 : _a.replace("Proxy.", "")) == null ? void 0 : _b.split(".")) == null ? void 0 : _c.slice(0);
    const className = (funcNameParts == null ? void 0 : funcNameParts.length) ? funcNameParts.shift() : "";
    const methodName = (_d = funcNameParts == null ? void 0 : funcNameParts.join(".")) != null ? _d : "";
    return {
      frame: {
        file_name: this.replaceRemotePathWithLocalPath((_e = frame == null ? void 0 : frame.getFileName()) != null ? _e : ""),
        line_number: (frame == null ? void 0 : frame.getLineNumber()) || 0,
        class: className,
        method: methodName,
        vendor_frame: (_g = (_f = frame == null ? void 0 : frame.getFileName()) == null ? void 0 : _f.includes("node_modules")) != null ? _g : false
      }
    };
  }
};
__name(CallerPayload, "CallerPayload");

// src/Payloads/ClearAllPayload.ts
var ClearAllPayload = class extends Payload {
  getType() {
    return "clear_all";
  }
};
__name(ClearAllPayload, "ClearAllPayload");

// src/Payloads/ColorPayload.ts
var ColorPayload = class extends Payload {
  constructor(color) {
    super();
    this.color = color;
  }
  getType() {
    return "color";
  }
  getContent() {
    return {
      color: this.color
    };
  }
};
__name(ColorPayload, "ColorPayload");

// src/Payloads/ConfettiPayload.ts
var ConfettiPayload = class extends Payload {
  getType() {
    return "confetti";
  }
};
__name(ConfettiPayload, "ConfettiPayload");

// src/Payloads/CreateLockPayload.ts
var CreateLockPayload = class extends Payload {
  constructor(name) {
    super();
    this.name = name;
  }
  getType() {
    return "create_lock";
  }
  getContent() {
    return {
      name: this.name
    };
  }
};
__name(CreateLockPayload, "CreateLockPayload");

// src/Payloads/CustomPayload.ts
var CustomPayload = class extends Payload {
  constructor(content, label = "") {
    super();
    this.content = content;
    this.label = label;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: this.content,
      label: this.label
    };
  }
};
__name(CustomPayload, "CustomPayload");

// src/Payloads/DatePayload.ts
import * as dayjs from "dayjs";
var DatePayload = class extends Payload {
  constructor(date, format2 = "YYYY-MM-DD hh:mm:ss") {
    super();
    this.date = date;
    this.format = format2;
  }
  getType() {
    return "carbon";
  }
  getContent() {
    return {
      formatted: this.date ? this.getFormatted() : null,
      timestamp: this.date ? this.getTimestamp() : null,
      timezone: this.date ? this.getTimezoneName() : null
    };
  }
  getTimestamp() {
    var _a;
    return dayjs.default((_a = this.date) == null ? void 0 : _a.toISOString()).unix();
  }
  getFormatted() {
    var _a;
    return dayjs.default((_a = this.date) == null ? void 0 : _a.toISOString()).format(this.format);
  }
  getTimezoneName() {
    if (this.date === null) {
      return "--";
    }
    const dateObj = this.date ? this.date : /* @__PURE__ */ new Date();
    const matches = /\((.*)\)/.exec(dateObj.toString());
    return matches ? matches[1] : "--";
  }
};
__name(DatePayload, "DatePayload");

// src/Payloads/DecodedJsonPayload.ts
var DecodedJsonPayload = class extends Payload {
  constructor(value) {
    super();
    this.value = value;
  }
  getType() {
    return "custom";
  }
  getContent() {
    const decodedJson = JSON.parse(this.value);
    return {
      // TODO: use ArgumentConverter
      content: decodedJson,
      //ArgumentConverter::convertToPrimitive(decodedJson),
      label: "JSON"
    };
  }
};
__name(DecodedJsonPayload, "DecodedJsonPayload");

// src/Payloads/ErrorPayload.ts
var ErrorPayload = class extends Payload {
  constructor(err, label = "Error") {
    super();
    this.err = err;
    this.label = label;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: this.formatError(),
      label: this.label
    };
  }
  formatError() {
    return `<span class="text-red-400 bold">${this.err.name}</span>: <br><span class="pl-5 text-gray-500">${this.err.message}</span>`;
  }
};
__name(ErrorPayload, "ErrorPayload");

// src/Payloads/EventPayload.ts
var EventPayload = class extends Payload {
  constructor(eventName, payload) {
    super();
    this.eventName = eventName;
    this.payload = payload;
  }
  getType() {
    return "event";
  }
  getContent() {
    return {
      name: this.eventName,
      event: this.payload[0],
      payload: ArgumentConverter.convertToPrimitive(this.payload).value,
      class_based_event: true
    };
  }
};
__name(EventPayload, "EventPayload");

// src/Payloads/ExceptionPayload.ts
import * as StackTrace from "stacktrace-js";
var ExceptionPayload = class extends Payload {
  constructor(exception, meta = {}) {
    super();
    this.meta = {};
    this.stack = StackTrace.getSync({});
    this.exception = exception;
    this.meta = meta;
  }
  getType() {
    return "exception";
  }
  getContent() {
    return {
      class: this.exception.name,
      message: this.exception.message,
      frames: this.getFrames(),
      meta: this.meta
    };
  }
  getFrames() {
    return this.stack.slice(1).map((frame) => {
      var _a, _b, _c, _d;
      const funcNameParts = (_b = (_a = frame.functionName) == null ? void 0 : _a.split(".")) != null ? _b : ["unknown", "unknown"];
      const methodName = funcNameParts.pop();
      let className = funcNameParts.pop();
      if (typeof className === "undefined") {
        className = "unknown";
      }
      return {
        file_name: this.replaceRemotePathWithLocalPath((_c = frame.getFileName()) != null ? _c : ""),
        line_number: frame.getLineNumber(),
        class: className,
        method: methodName,
        vendor_frame: (_d = frame.getFileName()) == null ? void 0 : _d.includes("node_modules"),
        snippet: []
      };
    }).filter((obj) => !obj.file_name.startsWith("node:")).filter((obj) => !obj.file_name.includes("jest-circus")).filter((obj) => obj.class !== "Ray" && obj.method !== "exception");
  }
};
__name(ExceptionPayload, "ExceptionPayload");

// src/Payloads/HideAppPayload.ts
var HideAppPayload = class extends Payload {
  getType() {
    return "hide_app";
  }
};
__name(HideAppPayload, "HideAppPayload");

// src/Payloads/HidePayload.ts
var HidePayload = class extends Payload {
  getType() {
    return "hide";
  }
};
__name(HidePayload, "HidePayload");

// src/lib/utils.ts
import { v4 as uuidv4 } from "uuid";
function randomInteger(minimum, maximum) {
  if (maximum === void 0) {
    maximum = minimum;
    minimum = 0;
  }
  if (typeof minimum !== "number" || typeof maximum !== "number") {
    throw new TypeError("Expected all arguments to be numbers");
  }
  return Math.floor(Math.random() * (maximum - minimum + 1) + minimum);
}
__name(randomInteger, "randomInteger");
var sleep = /* @__PURE__ */ __name((seconds) => {
  return usleep(seconds * 1e3);
}, "sleep");
var usleep = /* @__PURE__ */ __name((milliseconds) => {
  const start = (/* @__PURE__ */ new Date()).getTime();
  while ((/* @__PURE__ */ new Date()).getTime() < start + milliseconds) {
  }
}, "usleep");
var encodeHtmlEntities = /* @__PURE__ */ __name((str) => {
  const escapeChars = {
    "\xA2": "cent",
    "\xA3": "pound",
    "\xA5": "yen",
    "\u20AC": "euro",
    "\xA9": "copy",
    "\xAE": "reg",
    "<": "lt",
    ">": "gt",
    '"': "quot",
    "&": "amp",
    "'": "#39"
  };
  const chars = Object.keys(escapeChars);
  const regex = new RegExp(`[${chars.join("")}]`, "g");
  return str.replace(regex, (m) => `&${escapeChars[m]};`);
}, "encodeHtmlEntities");
var spacesToHtmlSpaces = /* @__PURE__ */ __name((spaces) => {
  return "&nbsp;".repeat(spaces.length);
}, "spacesToHtmlSpaces");
var encodeNewLinesToHtml = /* @__PURE__ */ __name((str) => {
  return str.replace(/(\r\n|\r|\n)/g, "<br>");
}, "encodeNewLinesToHtml");
var formatHtmlForDisplay = /* @__PURE__ */ __name((html, options = { encodeEntities: true }) => {
  if (options.encodeEntities) {
    html = encodeHtmlEntities(html);
  }
  return encodeNewLinesToHtml(
    html.replace(/^(\s+)/gm, (m) => `${spacesToHtmlSpaces(m)}`)
    // preserve indentation spaces
  );
}, "formatHtmlForDisplay");
var nonCryptoUuidV4 = /* @__PURE__ */ __name(() => {
  const v4options = {
    random: [
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255),
      randomInteger(1, 255)
    ]
  };
  return uuidv4(v4options).toString();
}, "nonCryptoUuidV4");
var end = /* @__PURE__ */ __name((arr) => arr.length ? arr[arr.length - 1] : false, "end");

// src/Payloads/HtmlMarkupPayload.ts
import formatXml from "xml-formatter";
var HtmlMarkupPayload = class extends Payload {
  constructor(value, options = { highlight: "none" }) {
    super();
    this.value = value;
    this.options = options;
  }
  getType() {
    return "custom";
  }
  getContent() {
    const content = this.formatMarkupForDisplay(this.value);
    return {
      content,
      label: "Markup"
    };
  }
  formatMarkupForDisplay(markup) {
    const content = this.formatAndIndentMarkup(markup);
    return this.highlightHtmlMarkup(formatHtmlForDisplay(content, { encodeEntities: true }));
  }
  formatAndIndentMarkup(markup) {
    return formatXml(markup.toString(), {
      indentation: "    ",
      //filter: (node) => node.type !== 'Comment',
      collapseContent: true,
      lineSeparator: "\n"
    });
  }
  highlightHtmlMarkup(markup) {
    return markup.replace(/&quot;/g, '"').replace(/="([^"]+)"/g, `=<span style='color:#16A34A;'>&quot;$1&quot;</span>`).replace(/(&lt;[A-Za-z\d-]+)(\s|&nbsp;|&gt;)/g, '<span style="color:#1D4ED8;">$1</span>$2').replace(/(&lt;\/[A-Za-z\d-]+)(&gt;)/g, '<span style="color:#1D4ED8;">$1$2</span>');
  }
};
__name(HtmlMarkupPayload, "HtmlMarkupPayload");

// src/Payloads/ImagePayload.ts
var ImagePayload = class extends Payload {
  constructor(location) {
    super();
    this.location = location;
  }
  getType() {
    return "custom";
  }
  getContent() {
    const location = this.location.replace('"', '\\\\"');
    return {
      content: `<img src="${location}" alt="" />`,
      label: "Image"
    };
  }
};
__name(ImagePayload, "ImagePayload");

// src/Payloads/JsonStringPayload.ts
var JsonStringPayload = class extends Payload {
  constructor(value) {
    super();
    this.value = value;
  }
  getType() {
    return "json_string";
  }
  getContent() {
    return {
      value: JSON.stringify(this.value)
    };
  }
};
__name(JsonStringPayload, "JsonStringPayload");

// src/Payloads/LabelPayload.ts
var LabelPayload = class extends Payload {
  constructor(label) {
    super();
    this.label = label;
  }
  getType() {
    return "label";
  }
  getContent() {
    return {
      label: this.label
    };
  }
};
__name(LabelPayload, "LabelPayload");

// src/Payloads/MeasurePayload.ts
var MeasurePayload = class extends Payload {
  constructor(name, stopwatchEvent) {
    super();
    /** @var boolean */
    this.isNewTimer = false;
    /** @var float|number */
    this.totalTime = 0;
    /** @var number */
    this.maxMemoryUsageDuringTotalTime = 0;
    /** @var float|number */
    this.timeSinceLastCall = 0;
    /** @var number */
    this.maxMemoryUsageSinceLastCall = 0;
    this.name = name;
    this.totalTime = stopwatchEvent.getDuration();
    this.maxMemoryUsageDuringTotalTime = stopwatchEvent.getMemory();
    const periods = stopwatchEvent.getPeriods();
    if (periods.length > 1) {
      this.timeSinceLastCall = end(periods);
      this.maxMemoryUsageSinceLastCall = 0;
    }
  }
  getType() {
    return "measure";
  }
  concernsNewTimer() {
    this.isNewTimer = true;
    this.totalTime = 0;
    this.maxMemoryUsageDuringTotalTime = 0;
    this.timeSinceLastCall = 0;
    this.maxMemoryUsageSinceLastCall = 0;
    return this;
  }
  getContent() {
    return {
      name: this.name,
      is_new_timer: this.isNewTimer,
      total_time: this.totalTime,
      max_memory_usage_during_total_time: this.maxMemoryUsageDuringTotalTime,
      time_since_last_call: this.timeSinceLastCall,
      max_memory_usage_since_last_call: this.maxMemoryUsageSinceLastCall
    };
  }
};
__name(MeasurePayload, "MeasurePayload");

// src/Payloads/NewScreenPayload.ts
var NewScreenPayload = class extends Payload {
  constructor(name) {
    super();
    this.name = name;
  }
  getType() {
    return "new_screen";
  }
  getContent() {
    return {
      name: this.name
    };
  }
};
__name(NewScreenPayload, "NewScreenPayload");

// src/Payloads/NotifyPayload.ts
var NotifyPayload = class extends Payload {
  constructor(text) {
    super();
    this.text = text;
  }
  getType() {
    return "notify";
  }
  getContent() {
    return {
      value: this.text
    };
  }
};
__name(NotifyPayload, "NotifyPayload");

// src/Payloads/RemovePayload.ts
var RemovePayload = class extends Payload {
  getType() {
    return "remove";
  }
};
__name(RemovePayload, "RemovePayload");

// src/Payloads/ScreenColorPayload.ts
var ScreenColorPayload = class extends Payload {
  constructor(color) {
    super();
    this.color = color;
  }
  getType() {
    return "screen_color";
  }
  getContent() {
    return {
      color: this.color
    };
  }
};
__name(ScreenColorPayload, "ScreenColorPayload");

// src/Payloads/SeparatorPayload.ts
var SeparatorPayload = class extends Payload {
  getType() {
    return "separator";
  }
};
__name(SeparatorPayload, "SeparatorPayload");

// src/Payloads/ShowAppPayload.ts
var ShowAppPayload = class extends Payload {
  getType() {
    return "show_app";
  }
};
__name(ShowAppPayload, "ShowAppPayload");

// src/Payloads/SizePayload.ts
var SizePayload = class extends Payload {
  constructor(size) {
    super();
    this.size = size;
  }
  getType() {
    return "size";
  }
  getContent() {
    return {
      size: this.size
    };
  }
};
__name(SizePayload, "SizePayload");

// src/Payloads/TablePayload.ts
var TablePayload = class extends Payload {
  constructor(values, label = "Table") {
    super();
    this.values = values;
    this.label = label;
  }
  getType() {
    return "table";
  }
  getContent() {
    const values = this.getValues();
    return {
      values,
      label: this.label
    };
  }
  getValues() {
    if (Array.isArray(this.values)) {
      return this.values.map((item) => {
        return ArgumentConverter.convertToPrimitive(item).value;
      });
    }
    const values = {};
    for (const prop in this.values) {
      values[prop] = ArgumentConverter.convertToPrimitive(this.values[prop]).value;
    }
    return values;
  }
};
__name(TablePayload, "TablePayload");

// src/Payloads/TextPayload.ts
var TextPayload = class extends Payload {
  // eslint-disable-next-line no-unused-vars
  constructor(text) {
    super();
    this.text = text;
  }
  getType() {
    return "custom";
  }
  getContent() {
    return {
      content: this.formatContent(),
      label: "Text"
    };
  }
  formatContent() {
    return formatHtmlForDisplay(this.text, { encodeEntities: true });
  }
};
__name(TextPayload, "TextPayload");

// src/Payloads/TracePayload.ts
var TracePayload = class extends Payload {
  constructor(frames) {
    super();
    this.startFromIndexNum = null;
    this.limitNum = null;
    this.frames = RemovesRayFrames.removeRayFrames(frames);
  }
  startFromIndex(index) {
    this.startFromIndexNum = index;
    return this;
  }
  limit(limit) {
    this.limitNum = limit;
    return this;
  }
  getType() {
    return "trace";
  }
  getContent() {
    var _a;
    let frames = this.frames.map((frame) => {
      var _a2, _b, _c, _d;
      const funcNameParts = (_a2 = frame.getFunctionName()) == null ? void 0 : _a2.replace("Proxy.", "").split(".").slice(0);
      const className = (funcNameParts == null ? void 0 : funcNameParts.length) ? funcNameParts.shift() : "";
      const methodName = (_b = funcNameParts == null ? void 0 : funcNameParts.join(".")) != null ? _b : "";
      return {
        file_name: this.replaceRemotePathWithLocalPath((_c = frame.getFileName()) != null ? _c : ""),
        line_number: frame.getLineNumber(),
        class: className,
        method: methodName,
        vendor_frame: (_d = frame.getFileName()) == null ? void 0 : _d.includes("node_modules")
      };
    });
    if (this.limitNum !== null) {
      frames = frames.slice((_a = this.startFromIndexNum) != null ? _a : 0, this.limitNum);
    }
    return { frames };
  }
};
__name(TracePayload, "TracePayload");

// src/Payloads/XmlPayload.ts
import * as xmlfmt from "xml-formatter";
var formatXml2 = xmlfmt.default;
var XmlPayload = class extends Payload {
  constructor(value) {
    super();
    this.value = value;
  }
  getType() {
    return "custom";
  }
  getContent() {
    const content = this.formatXmlForDisplay(this.value);
    return {
      content,
      label: "XML"
    };
  }
  formatXmlForDisplay(xml) {
    const content = this.formatAndIndentXml(xml);
    return this.encodeXml(content);
  }
  encodeXml(xml) {
    return formatHtmlForDisplay(xml, { encodeEntities: true });
  }
  formatAndIndentXml(xml) {
    return formatXml2(xml.toString(), {
      indentation: "    ",
      //filter: (node) => node.type !== 'Comment',
      collapseContent: true,
      lineSeparator: "\n"
    });
  }
};
__name(XmlPayload, "XmlPayload");

// src/Request.ts
var Request = class {
  constructor(uuid, payloads, meta = []) {
    this.uuid = uuid;
    this.payloads = payloads;
    this.meta = meta;
  }
  toArray() {
    return {
      uuid: this.uuid,
      payloads: this.payloads.map((payload) => payload.toArray()),
      meta: this.meta
    };
  }
  toJson() {
    return JSON.stringify(this.toArray());
  }
};
__name(Request, "Request");

// src/Client.ts
import axios from "axios";
var _Client = class {
  constructor(portNumber = 23517, host = "localhost", scheme = "http") {
    this.scheme = "http";
    this.portNumber = portNumber;
    this.host = host;
    this.scheme = scheme;
  }
  async init() {
    await this.updateRayAvailabilty();
  }
  isRayAvailable() {
    this.attemptAvailableReset();
    if (_Client.rayState === null) {
      this.updateRayAvailabilty();
    }
    if (_Client.rayState !== null) {
      return _Client.rayState;
    }
    return true;
  }
  attemptAvailableReset() {
    if (_Client.lastRayStateCheck !== null && (/* @__PURE__ */ new Date()).getTime() - _Client.lastRayStateCheck >= 3e4) {
      _Client.rayState = null;
    }
  }
  async updateRayAvailabilty() {
    let result = true;
    if (_Client.lastRayStateCheck !== null && (/* @__PURE__ */ new Date()).getTime() - _Client.lastRayStateCheck < 3e4) {
      return true;
    }
    _Client.lastRayStateCheck = (/* @__PURE__ */ new Date()).getTime();
    try {
      await axios.get(this.getUrlForPath("/locks/__availabilty_check"), {});
    } catch (err) {
      if (err.response) {
        result = true;
      } else if (err.request) {
        result = false;
      } else {
        result = false;
      }
    } finally {
      _Client.rayState = result;
    }
  }
  getUrlForPath(path) {
    var _a;
    path = path.replace(/^\//, "");
    return `${(_a = this.scheme) != null ? _a : "http"}://${this.host}:${this.portNumber}/${path}`;
  }
  async send(request) {
    if (_Client.rayState === null || _Client.lastRayStateCheck === null) {
      this.updateRayAvailabilty();
    }
    try {
      request.payloads = this.ensureAllPayloadsHaveAnOrigin(request.payloads);
      await axios.post(this.getUrlForPath("/"), request.toArray(), { withCredentials: false });
    } catch (err) {
    }
  }
  ensureAllPayloadsHaveAnOrigin(payloads) {
    payloads.forEach((payload) => {
      if (payload.data.origin.file === null || payload.data.origin.file === "" || typeof payload.data.origin["file"] === "undefined") {
        payload.data.origin["file"] = "/unknown-file.js";
        payload.data.origin["line_number"] = 1;
        payload.data.origin["function_name"] = "unknown";
      }
    });
    return payloads;
  }
  async lockExists(lockName) {
    return new Promise(async (resolve, reject) => {
      let resp;
      try {
        resp = await axios.get(this.getUrlForPath(`/locks/${lockName}`));
      } catch (err) {
        return false;
      }
      if (resp.data.stop_execution) {
        reject(new Error("stopping execution"));
        return;
      }
      if (typeof resp.data["active"] === "undefined") {
        resolve(resp.data);
        return;
      }
      resolve(resp.data);
    });
  }
};
var Client = _Client;
__name(Client, "Client");
Client.rayState = true;
Client.lastRayStateCheck = null;

// src/Settings/Settings.ts
var Settings = class {
  constructor(settings2) {
    this.enable = true;
    this._host = "localhost";
    this._port = 23517;
    this._scheme = "http";
    this.remote_path = null;
    this.local_path = null;
    this.always_send_raw_values = false;
    this.intercept_console_log = false;
    this.enabled_callback = null;
    this.sent_payload_callback = null;
    this.sending_payload_callback = null;
    this.originalSettings = Object.assign({}, settings2);
    for (const prop in settings2) {
      this[prop] = settings2[prop];
    }
  }
  set host(value) {
    this._host = value;
    Ray.useClient(new Client(this.port, this.host, this.scheme));
  }
  get host() {
    return this._host;
  }
  set port(value) {
    this._port = value;
    Ray.useClient(new Client(this.port, this.host, this.scheme));
  }
  get port() {
    return this._port;
  }
  get scheme() {
    return this._scheme;
  }
  set scheme(value) {
    this._scheme = value;
    Ray.useClient(new Client(this.port, this.host, this.scheme));
  }
  toObject() {
    return this.originalSettings;
  }
};
__name(Settings, "Settings");

// src/Stopwatch/StopwatchEvent.ts
var StopwatchEvent2 = class {
  constructor(sw, lapTime = null) {
    this.laps = [];
    var _a;
    this.name = (_a = sw.name) == null ? void 0 : _a.slice(0);
    this.laps = sw.laps.slice(0);
    this.startedAt = sw.startedAt;
    this.endedAt = sw.endedAt;
    this.lapTime = lapTime != null ? lapTime : (/* @__PURE__ */ new Date()).getTime();
  }
  getDuration() {
    return this.laps.reduce((prev, cur) => cur + prev, 0);
  }
  getMemory() {
    return 0;
  }
  getPeriods() {
    return this.laps.slice();
  }
  getPreviousDuration() {
    return end(this.laps) - ((/* @__PURE__ */ new Date()).getTime() - this.lapTime);
  }
};
__name(StopwatchEvent2, "StopwatchEvent");

// src/Stopwatch/Stopwatch.ts
var Stopwatch2 = class {
  constructor(name = void 0) {
    this.laps = [];
    this.startedAt = 0;
    this.endedAt = 0;
    this.name = name;
    this.laps = [];
    this.startedAt = 0;
    this.endedAt = 0;
  }
  initialize(name) {
    this.name = name;
    this.laps = [];
    this.startedAt = 0;
    this.endedAt = 0;
  }
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  start(name) {
    this.startedAt = (/* @__PURE__ */ new Date()).getTime();
    return new StopwatchEvent2(this);
  }
  lap() {
    const lapTime = (/* @__PURE__ */ new Date()).getTime();
    const duration = lapTime - this.startedAt;
    this.laps.push(duration - this.totalDuration());
    return new StopwatchEvent2(this, lapTime);
  }
  stop() {
    this.endedAt = (/* @__PURE__ */ new Date()).getTime();
    const duration = this.endedAt - this.startedAt;
    this.laps.push(duration - this.totalDuration());
    return new StopwatchEvent2(this);
  }
  totalDuration() {
    return this.laps.reduce((prev, cur) => {
      return cur + prev;
    }, 0);
  }
  reset() {
    this.initialize(this.name);
    return this;
  }
  getLaps() {
    return this.laps;
  }
};
__name(Stopwatch2, "Stopwatch");
var Stopwatch_default = Stopwatch2;

// src/Support/Counters.ts
var Counters = class {
  constructor() {
    this.counters = {};
  }
  increment(name) {
    if (typeof this.counters[name] === "undefined") {
      this.counters[name] = [ray(), 0];
    }
    const data = this.counters[name];
    const ray2 = data[0];
    const times = data[1];
    const newTimes = times + 1;
    this.counters[name] = [ray2, newTimes];
    return [ray2, newTimes];
  }
  get(name) {
    if (typeof this.counters[name] === "undefined") {
      return 0;
    }
    return this.counters[name][1];
  }
  clear() {
    this.counters = [];
  }
  setRay(name, ray2) {
    this.counters[name][0] = ray2;
  }
  getCounters() {
    return this.counters;
  }
};
__name(Counters, "Counters");

// src/Support/Limiters.ts
var Limiters = class {
  constructor() {
    this.counters = {};
  }
  initialize(origin, limit) {
    const fingerprint = `${origin.file}:${origin.line_number}`;
    if (typeof this.counters[fingerprint] === "undefined") {
      this.counters[fingerprint] = { counter: 0, limit, valid: true };
    }
    return this.counters[fingerprint];
  }
  increment(origin) {
    const name = `${origin.file}:${origin.line_number}`;
    if (typeof this.counters[name] === "undefined") {
      return { counter: 0, limit: 0, valid: false };
    }
    const { counter, limit, valid } = this.counters[name];
    this.counters[name] = { counter: counter + 1, limit, valid };
    return this.counters[name];
  }
  canSendPayload(origin) {
    const name = `${origin.file}:${origin.line_number}`;
    if (typeof this.counters[name] === "undefined") {
      return true;
    }
    const { counter, limit, valid } = this.counters[name];
    return valid && (counter < limit || limit <= 0);
  }
};
__name(Limiters, "Limiters");

// src/Support/CacheStore.ts
var CacheStore = class {
  constructor(clock) {
    this.store = [];
    this.clock = clock;
  }
  hit() {
    this.store.push(this.clock.now());
    return this;
  }
  clear() {
    this.store = [];
    return this;
  }
  count() {
    return this.store.length;
  }
  countLastSecond() {
    const lastSecond = this.clock.now().modify("-1 second");
    let amount = 0;
    this.store.forEach((item) => {
      if (this.isBetween(item, lastSecond, this.clock.now())) {
        amount++;
      }
    });
    return amount;
  }
  isBetween(toCheck, start, end2) {
    return toCheck.getTimestamp() >= start.getTimestamp() && toCheck.getTimestamp() <= end2.getTimestamp();
  }
};
__name(CacheStore, "CacheStore");

// src/Support/Clock.ts
var Clock2 = class {
};
__name(Clock2, "Clock");

// src/Support/DateImmutable.ts
import dayjs2 from "dayjs";
var DateImmutable3 = class {
  get date() {
    return dayjs2(this.dateStr).toDate();
  }
  set date(value) {
    this.dateTs = value.getTime();
    this.dateStr = value.toISOString();
  }
  static createFrom(date) {
    return new DateImmutable3(date);
  }
  constructor(date = null) {
    this.date = date != null ? date : /* @__PURE__ */ new Date();
    this.dateStr = this.date.toISOString();
    this.dateTs = this.date.getTime();
  }
  getTimestamp() {
    return Math.floor(this.dateTs / 1e3);
  }
  modify(str) {
    const strParts = str.split(" ");
    const parts = [];
    for (let idx = 0; idx < strParts.length; idx++) {
      parts.push({
        value: Number(strParts[idx]),
        unit: strParts[idx + 1]
      });
      idx++;
    }
    let tempDate = dayjs2(this.getTimestamp() * 1e3);
    parts.forEach((part) => {
      tempDate = tempDate.add(part.value * 1e3);
    });
    return DateImmutable3.createFrom(tempDate.toDate());
  }
};
__name(DateImmutable3, "DateImmutable");

// src/Support/SystemClock.ts
var SystemClock = class extends Clock2 {
  now() {
    return new DateImmutable3();
  }
};
__name(SystemClock, "SystemClock");

// src/Support/RateLimiter.ts
var RateLimiter = class {
  constructor(maxCalls = null, maxPerSecond = null) {
    this.notified = false;
    this.maxCalls = maxCalls;
    this.maxPerSecond = maxPerSecond;
    this.cache = new CacheStore(new SystemClock());
  }
  static disabled() {
    return new RateLimiter(null, null);
  }
  hit() {
    this.cache.hit();
    return this;
  }
  max(maxCalls = null) {
    this.maxCalls = maxCalls;
    return this;
  }
  perSecond(callsPerSecond = null) {
    this.maxPerSecond = callsPerSecond;
    return this;
  }
  isMaxReached() {
    if (this.maxCalls === null) {
      return false;
    }
    const reached = this.cache.count() >= this.maxCalls;
    if (!reached) {
      this.notified = false;
    }
    return reached;
  }
  isMaxPerSecondReached() {
    if (this.maxPerSecond === null) {
      return false;
    }
    const reached = this.cache.countLastSecond() >= this.maxPerSecond;
    if (reached === false) {
      this.notified = false;
    }
    return reached;
  }
  clear() {
    this.maxCalls = null;
    this.maxPerSecond = null;
    this.cache.clear();
    return this;
  }
  isNotified() {
    return this.notified;
  }
  notify() {
    this.notified = true;
  }
  getCache() {
    return this.cache;
  }
};
__name(RateLimiter, "RateLimiter");

// src/lib/version.ts
var PACKAGE_VERSION = "__buildVersion__";
var version_default = PACKAGE_VERSION;

// src/Ray.ts
var BUILDING_STANDALONE_LIB = typeof __BUILDING_STANDALONE_LIB__ !== "undefined" && __BUILDING_STANDALONE_LIB__ === "true";
import * as md5lib from "md5";
import * as StackTrace2 from "stacktrace-js";
var md5 = md5lib.default;
var getSync2 = StackTrace2.getSync;
var _Ray = class extends Mixin(RayColors, RaySizes, RayScreenColors) {
  constructor(settings2, client = null, uuid = null, inCallback = false) {
    var _a, _b, _c;
    super();
    this.inCallback = false;
    this.limitOrigin = null;
    this.canSendPayload = true;
    if (_Ray.defaultSettings.not_defined === true) {
      _Ray.defaultSettings = {
        enable: true,
        host: "localhost",
        port: 23517,
        scheme: "http",
        local_path: null,
        remote_path: null,
        always_send_raw_values: false,
        enabled_callback: null,
        sending_payload_callback: null,
        sent_payload_callback: null,
        not_defined: false
      };
    }
    this.inCallback = inCallback;
    this.settings = new Settings(_Ray.defaultSettings);
    if (_Ray.enabled === null) {
      _Ray.enabled = this.settings.enable !== false;
    }
    _Ray.client = (_a = client != null ? client : _Ray.client) != null ? _a : new Client(this.settings.port, this.settings.host);
    _Ray._rateLimiter = (_b = _Ray._rateLimiter) != null ? _b : RateLimiter.disabled();
    this.uuid = (_c = uuid != null ? uuid : _Ray.fakeUuid) != null ? _c : nonCryptoUuidV4();
    if (this.settings.intercept_console_log && !this.interceptor().active()) {
      this.interceptor().enable();
    }
    this.loadMacros();
  }
  static create(client = null, uuid = null) {
    if (_Ray.defaultSettings.not_defined === true) {
      _Ray.defaultSettings = {
        enable: true,
        host: "localhost",
        port: 23517,
        scheme: "http",
        local_path: null,
        remote_path: null,
        always_send_raw_values: false,
        not_defined: false,
        intercept_console_log: false,
        enabled_callback: null,
        sending_payload_callback: null,
        sent_payload_callback: null
      };
    }
    const settings2 = new Settings(_Ray.defaultSettings);
    return new this(settings2, client, uuid);
  }
  static useDefaultSettings(settings2) {
    if (_Ray.defaultSettings.not_defined === true) {
      _Ray.defaultSettings = {
        enable: true,
        host: "localhost",
        port: 23517,
        scheme: "http",
        local_path: null,
        remote_path: null,
        always_send_raw_values: false,
        enabled_callback: null,
        sending_payload_callback: null,
        sent_payload_callback: null,
        not_defined: false
      };
    }
    _Ray.defaultSettings = Object.assign({}, _Ray.defaultSettings, settings2);
    _Ray.defaultSettings.not_defined = false;
    _Ray.client = new Client(this.defaultSettings.port, this.defaultSettings.host);
    return this;
  }
  loadMacros() {
    for (const name in _Ray.macros) {
      const handler = _Ray.macros[name];
      this[name] = handler.bind(this);
    }
    return this;
  }
  interceptor() {
    return _Ray.interceptor;
  }
  client() {
    return _Ray.client;
  }
  enable() {
    _Ray.enabled = true;
    return this;
  }
  disable() {
    _Ray.enabled = false;
    return this;
  }
  enabled() {
    if (typeof this.settings.enabled_callback === "function") {
      return _Ray.enabled && this.settings.enabled_callback();
    }
    return _Ray.enabled;
  }
  disabled() {
    return !this.enabled();
  }
  static useClient(client) {
    this.client = client;
  }
  project(projectName) {
    _Ray.projectName = projectName;
    return this;
  }
  newScreen(name = "") {
    const payload = new NewScreenPayload(name);
    return this.sendRequest(payload);
  }
  clearAll() {
    const payload = new ClearAllPayload();
    return this.sendRequest(payload);
  }
  clearScreen() {
    return this.newScreen();
  }
  color(color) {
    const payload = new ColorPayload(color);
    return this.sendRequest(payload);
  }
  confetti() {
    const payload = new ConfettiPayload();
    return this.sendRequest(payload);
  }
  screenColor(color) {
    const payload = new ScreenColorPayload(color);
    return this.sendRequest(payload);
  }
  label(label) {
    const payload = new LabelPayload(label);
    return this.sendRequest(payload);
  }
  size(size) {
    const payload = new SizePayload(size);
    return this.sendRequest(payload);
  }
  remove() {
    const payload = new RemovePayload();
    return this.sendRequest(payload);
  }
  hide() {
    const payload = new HidePayload();
    return this.sendRequest(payload);
  }
  notify(text) {
    const payload = new NotifyPayload(text);
    return this.sendRequest(payload);
  }
  toJson(...values) {
    const payloads = values.map((value) => new JsonStringPayload(value));
    return this.sendRequest(payloads);
  }
  json(...jsons) {
    const payloads = jsons.map((json) => new DecodedJsonPayload(json));
    return this.sendRequest(payloads);
  }
  file(filename) {
    console.error(`file() unsupport on web (${filename})`);
    return this;
  }
  image(location) {
    const payload = new ImagePayload(location);
    return this.sendRequest(payload);
  }
  die(status = "") {
    throw new Error(`Ray.die() called: ${status ? status : "no message"}`);
  }
  className(object) {
    return this.send(object.constructor.name);
  }
  error(err) {
    const payload = new ErrorPayload(err, "Error");
    this.sendRequest(payload);
    this.red();
    return this;
  }
  event(eventName, data = []) {
    const payload = new EventPayload(eventName, data);
    return this.sendRequest(payload);
  }
  exception(err, meta = {}) {
    const payload = new ExceptionPayload(err, meta);
    this.sendRequest(payload);
    this.red();
    return this;
  }
  /**
   * @deprecated Use `if` instead of this method
   */
  showWhen(booleanOrCallable) {
    if (typeof booleanOrCallable === "function") {
      booleanOrCallable = booleanOrCallable();
    }
    if (!booleanOrCallable) {
      this.remove();
    }
    return this;
  }
  /**
   * @deprecated Use `if` instead of this method
   */
  showIf(booleanOrCallable) {
    return this.showWhen(booleanOrCallable);
  }
  /**
   * @deprecated Use `if` instead of this method
   */
  removeWhen(booleanOrCallable) {
    if (typeof booleanOrCallable === "function") {
      booleanOrCallable = booleanOrCallable();
    }
    if (booleanOrCallable) {
      this.remove();
    }
    return this;
  }
  /**
   * @deprecated Use `if` instead of this method
   */
  removeIf(booleanOrCallable) {
    return this.removeWhen(booleanOrCallable);
  }
  ban() {
    return this.send("\u{1F576}");
  }
  charles() {
    return this.send("\u{1F3B6} \u{1F3B9} \u{1F3B7} \u{1F57A}");
  }
  table(values, label = "Table") {
    const payload = new TablePayload(values, label);
    return this.sendRequest(payload);
  }
  count(name = null) {
    var _a, _b, _c;
    const fingerprint = md5(`${(_a = this.getCaller()) == null ? void 0 : _a.getFileName()}${(_b = this.getCaller()) == null ? void 0 : _b.getLineNumber()}`);
    const [ray2, times] = _Ray.counters.increment((_c = name != null ? name : fingerprint) != null ? _c : "none");
    let message = `Called `;
    if (name) {
      message += `'${name}' `;
    }
    message += `${times} ${times === 1 ? "time" : "times"}.`;
    ray2.sendCustom(message, "Count");
    return ray2;
  }
  clearCounters() {
    _Ray.counters.clear();
    return this;
  }
  async pause() {
    _Ray.lockCounter++;
    const lockName = md5(`${(/* @__PURE__ */ new Date()).getTime()}-${_Ray.lockCounter}`);
    const payload = new CreateLockPayload(lockName);
    this.sendRequest(payload);
    return new Promise(async (resolve, reject) => {
      let exists;
      do {
        sleep(1);
        try {
          exists = await _Ray.client.lockExists(lockName);
        } catch (err) {
          reject(err);
          return false;
        }
        if (exists !== true && exists && exists.stop_execution) {
          reject(false);
          return false;
        }
      } while (exists.active);
      resolve(this);
    });
  }
  stopTime(stopwatchName = "") {
    if (stopwatchName === "") {
      _Ray.stopWatches = {};
      return this;
    }
    if (typeof _Ray.stopWatches[stopwatchName] !== "undefined") {
      delete _Ray.stopWatches[stopwatchName];
    }
    return this;
  }
  caller() {
    const backtrace = getSync2({});
    const payload = new CallerPayload(backtrace);
    return this.sendRequest(payload);
  }
  trace() {
    const backtrace = getSync2({});
    const payload = new TracePayload(backtrace);
    return this.sendRequest(payload);
  }
  measure(stopwatchName = "default") {
    if (stopwatchName instanceof Function) {
      return this.measureClosure(stopwatchName);
    }
    if (typeof _Ray.stopWatches[stopwatchName] === "undefined") {
      const stopwatch2 = this.getStopwatch(stopwatchName);
      _Ray.stopWatches[stopwatchName] = stopwatch2;
      const event2 = stopwatch2.start(stopwatchName);
      const payload2 = this.getMeasurePayload(stopwatchName, event2);
      payload2.concernsNewTimer();
      return this.sendRequest(payload2);
    }
    const stopwatch = _Ray.stopWatches[stopwatchName];
    const event = stopwatch.lap();
    const payload = this.getMeasurePayload(stopwatchName, event);
    return this.sendRequest(payload);
  }
  measureClosure(closure) {
    const stopwatch = this.getStopwatch("closure");
    stopwatch.start("closure");
    closure();
    const event = stopwatch.stop();
    const payload = this.getMeasurePayload("closure", event);
    return this.sendRequest(payload);
  }
  getStopwatch(name) {
    return new Stopwatch2(name);
  }
  getMeasurePayload(name, event) {
    return new MeasurePayload(name, event);
  }
  separator() {
    const payload = new SeparatorPayload();
    return this.sendRequest(payload);
  }
  xml(xml) {
    const payload = new XmlPayload(xml);
    return this.sendRequest(payload);
  }
  html(html = "") {
    const payload = new HtmlPayload(html);
    return this.sendRequest(payload);
  }
  text(text = "") {
    const payload = new TextPayload(text);
    return this.sendRequest(payload);
  }
  date(date) {
    const payload = new DatePayload(date);
    return this.sendRequest(payload);
  }
  raw(...args) {
    if (!args.length) {
      return this;
    }
    const payloads = args.map((arg) => LogPayload.createForArguments([arg]));
    return this.sendRequest(payloads);
  }
  send(...args) {
    if (!args.length) {
      return this;
    }
    if (this.settings.always_send_raw_values) {
      return this.raw(...args);
    }
    const payloads = PayloadFactory.createForValues(args);
    return this.sendRequest(payloads);
  }
  pass(argument) {
    this.send(argument);
    return argument;
  }
  showApp() {
    const payload = new ShowAppPayload();
    return this.sendRequest(payload);
  }
  hideApp() {
    const payload = new HideAppPayload();
    return this.sendRequest(payload);
  }
  macro(name, handler) {
    _Ray.macros[name] = handler;
    this[name] = handler.bind(this);
    return this;
  }
  htmlMarkup(html, options = {}) {
    const payload = new HtmlMarkupPayload(html, options);
    return this.sendRequest(payload);
  }
  if(boolOrCallable, callback = null) {
    if (typeof boolOrCallable === "function") {
      boolOrCallable = boolOrCallable();
    }
    if (boolOrCallable && callback !== null) {
      callback(this);
    }
    if (callback === null) {
      this.canSendPayload = boolOrCallable;
    }
    return this;
  }
  limit(count) {
    const frame = this.getOriginFrame();
    this.limitOrigin = {
      function_name: frame == null ? void 0 : frame.getFunctionName(),
      file: frame == null ? void 0 : frame.getFileName(),
      line_number: frame == null ? void 0 : frame.getLineNumber(),
      hostname: Hostname.get()
    };
    _Ray.limiters.initialize(this.limitOrigin, count);
    return this;
  }
  once(...args) {
    const frame = this.getOriginFrame();
    this.limitOrigin = {
      function_name: frame == null ? void 0 : frame.getFunctionName(),
      file: frame == null ? void 0 : frame.getFileName(),
      line_number: frame == null ? void 0 : frame.getLineNumber(),
      hostname: Hostname.get()
    };
    _Ray.limiters.initialize(this.limitOrigin, 1);
    if (args.length > 0) {
      return this.send(...args);
    }
    return this;
  }
  sendCustom(content, label = "") {
    const payload = new CustomPayload(content, label);
    return this.sendRequest(payload);
  }
  getOriginFrame() {
    const st = getSync2({});
    let startFrameIndex = st.findIndex((frame) => {
      var _a;
      return (_a = frame.functionName) == null ? void 0 : _a.includes("Ray.sendRequest");
    });
    if (startFrameIndex === -1) {
      startFrameIndex = 0;
    }
    const callerFrames = RemovesRayFrames.removeRayFrames(st.slice(startFrameIndex));
    return callerFrames.slice(0).shift();
  }
  getCaller() {
    const st = getSync2({});
    let startFrameIndex = st.findIndex((frame) => {
      var _a;
      return (_a = frame.functionName) == null ? void 0 : _a.includes("Ray.getCaller");
    });
    if (startFrameIndex === -1) {
      startFrameIndex = 0;
    }
    const callerFrames = st.slice(startFrameIndex);
    if (callerFrames.length === 1) {
      return callerFrames.shift();
    }
    return callerFrames.slice(2).shift();
  }
  getOriginData() {
    const frame = this.getOriginFrame();
    return {
      function_name: frame == null ? void 0 : frame.getFunctionName(),
      file: frame == null ? void 0 : frame.getFileName(),
      line_number: frame == null ? void 0 : frame.getLineNumber(),
      hostname: Hostname.get()
    };
  }
  sendRequest(payloads, meta = []) {
    var _a;
    if (!this.enabled()) {
      return this;
    }
    if (!this.canSendPayload) {
      return this;
    }
    if (this.limitOrigin !== null) {
      if (!_Ray.limiters.canSendPayload(this.limitOrigin)) {
        return this;
      }
      _Ray.limiters.increment(this.limitOrigin);
    }
    if (!Array.isArray(payloads)) {
      payloads = [payloads];
    }
    if (this.rateLimiter().isMaxReached() || this.rateLimiter().isMaxPerSecondReached()) {
      this.notifyWhenRateLimitReached();
      return this;
    }
    const allMeta = Object.assign(
      {},
      {
        node_ray_package_version: version_default,
        project_name: _Ray.projectName
      },
      meta
    );
    payloads.forEach((payload) => {
      payload.data.origin = this.getOriginData();
      payload.remotePath = this.settings.remote_path;
      payload.localPath = this.settings.local_path;
    });
    if (this.settings.sending_payload_callback !== null && !this.inCallback) {
      this.inCallback = true;
      this.settings.sending_payload_callback(new _Ray(this.settings, this.client(), this.uuid, true), payloads);
      this.inCallback = false;
    }
    const request = new Request(this.uuid, payloads, allMeta);
    (_a = _Ray.client) == null ? void 0 : _a.send(request);
    this.rateLimiter().hit();
    if (this.settings.sent_payload_callback !== null && !this.inCallback) {
      this.inCallback = true;
      this.settings.sent_payload_callback(this);
      this.inCallback = false;
    }
    return this;
  }
  rateLimiter() {
    return _Ray._rateLimiter;
  }
  notifyWhenRateLimitReached() {
    if (this.rateLimiter().isNotified()) {
      return;
    }
    const customPayload = new CustomPayload("Rate limit has been reached...", "Rate limit");
    const request = new Request(this.uuid, [customPayload], []);
    _Ray.client.send(request);
    this.rateLimiter().notify();
  }
  standalone(windowObject) {
    if (typeof windowObject !== "undefined") {
      windowObject["ray"] = ray;
      windowObject["Ray"] = _Ray;
    }
  }
};
var Ray = _Ray;
__name(Ray, "Ray");
Ray.lockCounter = 0;
Ray.defaultSettings = { not_defined: true };
Ray.projectName = "";
Ray.counters = new Counters();
Ray.limiters = new Limiters();
Ray.interceptor = new ConsoleInterceptor();
// @var \Symfony\Component\Stopwatch\Stopwatch[]
Ray.stopWatches = {};
Ray.enabled = null;
Ray.macros = {};
Ray._rateLimiter = RateLimiter.disabled();
var ray = /* @__PURE__ */ __name((...args) => {
  return Ray.create().send(...args);
}, "ray");
var standalone = /* @__PURE__ */ __name((windowObject) => {
  if (typeof windowObject !== "undefined") {
    windowObject["ray"] = ray;
    windowObject["Ray"] = Ray;
  }
}, "standalone");
function standaloneInitialization() {
  if (typeof globalThis["window"] !== "undefined") {
    window["Ray"] = {
      ray,
      Ray
    };
    window["rayInit"] = standalone;
  }
}
__name(standaloneInitialization, "standaloneInitialization");
export {
  Ray,
  ray,
  standalone
};
